// extracted by mini-css-extract-plugin
export var card = "_lv-1";
export var summary = "_lv-0";